export class PopinModalConfig
{
    width?: number;
    hasBackdrop?: boolean;
}
